import {
  EntityDropdownInput,
  EntityDropdownProps,
} from "#src/batteries-included-components/Dropdowns/EntityDropdownInput";
import { WorkflowTasksViewFiltersType } from "#src/batteries-included-components/FilterAreas/WorkflowTasksFilterAreas/WorkflowTasksFilterAreas";
import { useStickyState } from "#src/hooks/useStickyState";
import { type StorageKeys } from "@validereinc/common-components";
import {
  UserGroupsAdapter,
  type UserGroupType,
  UsersAdapter,
  type UserType,
} from "@validereinc/domain";
import React, { useState } from "react";

export const WorkflowTaskUserGroupDropdownGroups = {
  USERS: "users",
  GROUPS: "groups",
} as const;

export type WorkflowTaskUserGroupDropdownGroupsType =
  (typeof WorkflowTaskUserGroupDropdownGroups)[keyof typeof WorkflowTaskUserGroupDropdownGroups];

export const WorkflowTaskUserGroupDropdown = (
  props: Omit<
    EntityDropdownProps<UserType | UserGroupType>,
    "fetchEntityList"
  > & {
    viewConfigStorageKey: StorageKeys["viewConfigStorageKey"];
  }
) => {
  const { viewConfigStorageKey, ...restProps } = props;
  const [filters, setFilters] = useStickyState<WorkflowTasksViewFiltersType>(
    {} as WorkflowTasksViewFiltersType,
    viewConfigStorageKey
  );
  const currentGroup =
    filters.assignee?.[0] ?? WorkflowTaskUserGroupDropdownGroups.USERS;
  const [activeGroup, setActiveGroup] = useState<string>(currentGroup);
  const adapter =
    activeGroup === WorkflowTaskUserGroupDropdownGroups.USERS
      ? UsersAdapter.getList
      : UserGroupsAdapter.getList;

  return (
    <EntityDropdownInput<UserType | UserGroupType>
      isMulti={false}
      onGroupChange={(newGroup) => {
        setActiveGroup(newGroup);
      }}
      onChange={(val) => {
        setFilters((prev) => ({
          ...prev,
          assignee: val,
        }));
      }}
      groups={[
        { id: WorkflowTaskUserGroupDropdownGroups.USERS, name: "Users" },
        {
          id: WorkflowTaskUserGroupDropdownGroups.GROUPS,
          name: "User Groups",
        },
      ]}
      defaultGroup={currentGroup}
      fetchEntityList={adapter}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...restProps}
    />
  );
};
